export async function loadByOrder(files) {
	for (let step of files) {
		await Promise.all(step.map(file => {
			console.info("funcs.loadByOrder: load " + file);
			return window.System.import(file);
		}));
		// await getPromiseTimeout(300);
	}
};

// export const getPromiseTimeout = (time) => new Promise(ok => setTimeout(ok, time));
